import "../styles/connectfour.css"
import { useImperativeHandle, useRef, useState } from "preact/hooks"
import Placeholder from "./Placeholder"
import { Colors, Players } from "./enum/Players"
import { Method } from "./enum/Game"
import { forwardRef } from "preact/compat"

export default forwardRef(({user, children, num, onClick = () => {}, enabled = false, method = Method.OFFLINE}, ref) => {
    const plholder = useRef(null)
    const [cells, setCells] = useState(children)
    const [full, setFull] = useState(cells.filter(x => x == null).length == 0)

    useImperativeHandle(ref, () => ({
        refresh(position, user) {
            const copy = [...cells]
            copy[position] = user
            console.log(copy)
            setCells(copy);
        }
    }))

    const over = () => {
        if (full || !enabled || !plholder.current) return;
        plholder.current.toggle(user)
    }

    const leave = () => {
        if (!enabled || !plholder.current) return;

        plholder.current.toggle()
    }

    const click = () => {
        if (!enabled || full) return;

        let set = null
        const current = cells.reverse().map((c, i) => {
            if (set == null && c == null) {
                set = cells.length - parseInt(i)
                return user
            }

            return c;
        }).reverse()

        if (set == null) return;

        onClick(num, set)
        setCells(current)

        const columnFull = current.filter(x => x == null).length == 0

        setFull(columnFull)

        if (method == Method.ONLINE || columnFull) plholder.current.toggle()
        else plholder.current.toggle(user == Players.Host ? Players.Guest : Players.Host)
    }

    return <div onClick = {click} onMouseOver = {over} onMouseLeave = {leave} className = "column">
        <Placeholder ref = {plholder} />
        {
            cells.map(cell => cell !== null ? 
                <div className = "circle" style={{ background: Colors[cell] }}></div> : 
                <div className = "cell"></div>
            )
        }
    </div>
})